import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from 'src/components/button/button.component';
import { InputNumberComponent } from 'src/components/input/input-number.component';
import { InputPhoneExtComponent } from 'src/components/input/input-phone-ext.component';
import { InputTextComponent } from 'src/components/input/input-text.component';
import { Form, FormError } from 'src/definitions/form.definition';
import { CreateKaryawanForm } from 'src/definitions/karyawan.definition';
import { FormService } from 'src/services/form.service';
import { ToastService } from 'src/services/toast.service';
import { GlobalService } from 'src/services/global.service';

export type ContactForm = Pick<
  CreateKaryawanForm,
  'phone' | 'phone_ext' | 'email' | 'instagram_url' | 'facebook_url' | 'tiktok_url'
>;

@Component({
  selector: 'step-3',
  templateUrl: './step-3.component.html',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    InputTextComponent,
    InputNumberComponent,
    InputPhoneExtComponent,
  ],
})
export class _Step3Component {
  @Input()
  isEdit: boolean = false;

  @Input()
  form!: Form<ContactForm>;

  @Input()
  formError!: FormError<ContactForm>;

  @Output()
  next = new EventEmitter<void>();

  @Output()
  back = new EventEmitter<void>();

  constructor(
    protected formService: FormService,
    protected toastService: ToastService,
protected globalService: GlobalService,
  ) {}

  protected _next() {
    if (this.form.invalid) {
      const invalid = this.formService.validateAndGetErrorMessage(this.form, this.formError);
      this.toastService.showToast({
        summary: invalid,
        detail: 'Cek ulang isian',
        severity: 'error',
      });
      return;
    }

    this.next.emit();
  }
}
